import React, {useEffect, useState} from 'react';
import "./blog.css";
import blogPosts from "../../article_manifest.json";

export interface BlogPost {
	id: number;
	title: string;
	date: string;
	snippet: string;
	tag: string;
	imageUrl: string;
	content?: string; // for expanded view
	isExpanded?: boolean;
}

const Blog: React.FC = () => {
	const [posts, setPosts] = useState<BlogPost[]>(
		blogPosts.map(post => ({...post, isExpanded:false}))
	);

	const toggleExpand = (id: number) => {
		setPosts(posts.map(post => 
			post.id === id 
				? { ...post, isExpanded : !post.isExpanded }
				: { ...post, isExpanded : false }
		));
	};

	return (
		<div className='blog-wrapper'>
			<span className='blog-span'>Learn More About Our Insights</span>
			<div className='blog-post-wrapper'>
				{posts.map(post => (
					<article
						key={post.id}
						className={`blog-post ${post.isExpanded ? 'expanded' : ''}`}
						aria-expanded={post.isExpanded}
					>
						<div className="blog-image-container">
							<img src={post.imageUrl} alt={post.title} />
							<div className='blog-tag'>{post.tag}</div>
						</div>

						<div className='blog-content'>
							<span className='blog-date'>{post.date}</span>
							<h3 className='blog-title'>{post.title}</h3>
							<div className='blog-text-snippet'>
								<p className='blog-snippet'>{post.snippet}</p>
								{post.isExpanded && post.content && (
									<div>
										{post.content.split('\n').map((paragraph, i) => (
											<p key={i}>{paragraph}</p>
										))}
									</div>
								)}
							</div>
							<a className='read-more' href={post.content}>Read More</a>
						</div>
					</article>
				))}
			</div>
			<div>
				<svg className="blog-wave" viewBox="0 0 1440 100" preserveAspectRatio="none">
      	  <path d="M0,0 C480,100 960,0 1440,100 L1440,0 L0,0 Z" fill="var(--color6)" />
      	</svg>
			</div>
		</div>
	);
}

export default Blog;

// TODO:
// Only grab the first few blog posts
